var _a;
import { PROPERTY_SHIPPING_PLACE, PROPERTY_SHIPPING_SLOT, PROPERTY_SHIPPING_TYPE, } from "@constants/index";
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["Doorstep"] = "doorstep";
    DeliveryType["Pickup"] = "pickup";
})(DeliveryType || (DeliveryType = {}));
export var DELIVERY_TYPE_LABELS = (_a = {},
    _a[DeliveryType.Pickup] = "Pickup",
    _a[DeliveryType.Doorstep] = "Doorstep",
    _a);
export var DELIVERY_TYPE_STR_TO_ENUM = {};
for (var _i = 0, _b = Object.entries(DELIVERY_TYPE_LABELS); _i < _b.length; _i++) {
    var _c = _b[_i], key = _c[0], value = _c[1];
    DELIVERY_TYPE_STR_TO_ENUM[value.toLowerCase()] = key;
}
